import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { AnalyticsFlowProvider } from '@utils/analytics/flow';
import { formatArtistNames, renderShopifyArtistName } from '@utils/artists';

import { FF_PRODUCT_TILE_SUBSCRIPTION_BUTTON } from '../../../../constants/featureFlags';
import { useCurrency } from '../../../../hooks/useCurrency';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';
import { DialogFlowWithStripe } from '../../Dialog/DialogFlowWithStripe';

/**
 * Modal hosts for draw flows. Must stay mounted while a draw flow is active —
 * see DrawFlow and UpcomingDrawDialog.
 */
export const DrawFlowDialogHosts = () => {
  const [currency] = useCurrency();
  const {
    activeDraw,
    customerSelectedFrame,
    entryIntentResponse,
    setupSecret,
  } = usePreAuthDrawCtx();

  const experimentalProductTileSubscriptionButton = useFeatureIsOn(
    FF_PRODUCT_TILE_SUBSCRIPTION_BUTTON,
  );

  return (
    <>
      <AnalyticsFlowProvider
        name="draw"
        properties={{
          'product title': activeDraw?.product.title,
          'artist name': renderShopifyArtistName(
            activeDraw?.product.artists[0]?.name ?? '',
          ),
          'product price': activeDraw?.product.price,
          'product can be framed': Boolean(activeDraw?.frames?.length),
          'product frame upgrade available': Boolean(activeDraw?.frames),
          'product frame chosen': Boolean(customerSelectedFrame),
          experimentalProductTileSubscriptionButton,
          ecommerce: {
            currency,
            transaction_id: entryIntentResponse.intent?.id,
            value: activeDraw?.product.price ?? '',
            items: [
              {
                item_id: activeDraw?.product.shopifyId,
                item_name: activeDraw?.product.title,
                item_brand: formatArtistNames(
                  activeDraw?.product.artistIds ?? [],
                ),
                item_category: activeDraw?.product.medium,
                price: activeDraw?.product.price,
                quantity: 1,
              },
            ],
          },
        }}
      >
        {() =>
          setupSecret && <DialogFlowWithStripe clientSecret={setupSecret} />
        }
      </AnalyticsFlowProvider>
    </>
  );
};
